import { PageTabs, PageTabsBar } from '@liscio/ui';

/** The id of the SMS admin page content, the panel of its one tab. */
export const SMS_ADMIN_PANEL_ID = 'sms-admin-tabpanel';
export const SMS_ADMIN_TAB_ID = 'sms-admin-tab-phone-lines';

const tabs = [
  {
    label: 'Phone Lines',
    value: 'phoneLines',
    id: SMS_ADMIN_TAB_ID,
    'aria-controls': SMS_ADMIN_PANEL_ID,
    href: '/sms-admin',
  },
];

export function SMSAdminHeader() {
  return (
    <PageTabsBar>
      <PageTabs
        aria-label="SMS admin tab"
        options={tabs}
        value="phoneLines"
        onChange={() => {}} // no-op: the page has one tab
      />
    </PageTabsBar>
  );
}
